/** Widget kartasining o'ng tugma menyusi (test: menu.test.ts). Bajarib bo'lmaydigan amal ko'rsatilmaydi. */
import { Eye, EyeOff, Scaling, SlidersHorizontal, Trash2 } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import { canToggleGlance, inGlance } from "./layout";
import type { Layout, WidgetDef, WidgetItem, WidgetSize } from "./types";

export interface WidgetMenuActions {
  settings: () => void;
  resize: (size: WidgetSize) => void;
  toggleGlance: () => void;
  remove: () => void;
}

export function widgetMenu(
  item: WidgetItem,
  def: Pick<WidgetDef, "sizes">,
  layout: Pick<Layout, "items" | "glance">,
  a: WidgetMenuActions,
  t: (key: string) => string,
): MenuEntry[] {
  const shown = inGlance(layout, item.id);
  return compactMenu([
    { key: "settings", label: t("menu.settings"), icon: SlidersHorizontal, onSelect: a.settings },
    def.sizes.length > 1 && {
      key: "size",
      label: t("menu.size"),
      icon: Scaling,
      hint: t(`size.${item.size}`),
      items: def.sizes.map((s) => ({ key: `size-${s}`, label: t(`size.${s}`), checked: s === item.size, onSelect: () => a.resize(s) })),
    },
    canToggleGlance(layout, item.id) && {
      key: "glance",
      label: t(shown ? "menu.hideTop" : "menu.showTop"),
      icon: shown ? EyeOff : Eye,
      onSelect: a.toggleGlance,
    },
    SEPARATOR,
    { key: "remove", label: t("menu.remove"), icon: Trash2, danger: true, onSelect: a.remove },
  ]);
}
